import { type FC, Fragment } from 'react'
import { KTSVG } from '_metronic/helpers'
import { ClientSideTable } from 'Presentation/Components/Table'
import ProjectEventLogForm from '../Form/View'

import useViewModel from './ViewModel'

const ProjectEventLogListView: FC = () => {
  const { data, columns, isOpenCreateNoteModal, setIsOpenCreateNoteModal, onAfterSaveNote } =
    useViewModel()

  return (
    <Fragment>
      <ProjectEventLogForm
        isOpen={isOpenCreateNoteModal}
        onClose={() => setIsOpenCreateNoteModal(false)}
        onSave={onAfterSaveNote}
      />

      <div className='card'>
        <div className='card-header'>
          <div className='card-title'></div>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-primary me-2 cursor-pointer'
              onClick={() => setIsOpenCreateNoteModal(true)}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                svgClassName='svg-icon-1x svg-primary'
              />
              <span>เพิ่มบันทึกเหตุการณ์</span>
            </button>
          </div>
        </div>

        <div className='card-body px-0'>
          <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} />
        </div>
      </div>
    </Fragment>
  )
}

export default ProjectEventLogListView
